import { graphql } from 'gatsby';

export { default } from './Publications';

export const pageQuery = graphql`
  query PublicationsQuery {
    markdownRemark(
      fileAbsolutePath: { regex: "/research/publications/index.md/" }
    ) {
      html
      frontmatter {
        publications {
          date
          author
          title
          text_md
          links {
            link {
              text
              url
              file {
                publicURL
              }
            }
          }
        }
      }
    }
  }
`;
